import React from 'react'

export default function Cashier() {
  return (
    <div>Cashier</div>
  )
}
